import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { adminApi, errorMessage } from "../../lib/api";
import { inr } from "../landing/usePricing";
import { UpiPay } from "../payments/UpiPay";

const inp = "h-8 border border-white/15 bg-[#0B1120] px-2 font-mono text-xs";

const Row = ({ r, onDone }) => {
  const [upi, setUpi] = useState(r.upi_id || "");
  const [utr, setUtr] = useState("");
  const sent = () => adminApi.post(`/admin/payments/refunds/${r.id}/sent`, { upi_id: upi.trim(), utr: utr || null })
    .then(() => { toast.success("Refund marked as sent"); onDone(); }).catch((e) => toast.error(errorMessage(e)));
  return (
    <div data-testid={`refund-row-${r.id}`} className="flex flex-wrap items-center justify-between gap-2 border border-white/10 px-3 py-2 text-sm">
      <span>{r.reference} · {r.customer_name} {r.customer_phone} · <b>{inr(r.amount)}</b></span>
      {r.status === "sent" ? (
        <span data-testid={`refund-sent-${r.id}`} className="text-xs text-emerald-300">Sent to {r.upi_id}{r.utr ? ` · UTR ${r.utr}` : ""} · {new Date(r.sent_at).toLocaleDateString("en-IN")}</span>
      ) : (
        <span className="flex flex-wrap gap-2">
          <input value={upi} onChange={(e) => setUpi(e.target.value)} placeholder="customer@upi" data-testid={`refund-upi-${r.id}`} className={`${inp} w-44`} />
          <input value={utr} onChange={(e) => setUtr(e.target.value.replace(/\D/g, "").slice(0, 12))} placeholder="UTR (optional)" data-testid={`refund-utr-${r.id}`} className={`${inp} w-32`} />
          <button disabled={!upi.includes("@") || (utr && utr.length !== 12)} onClick={sent} data-testid={`refund-mark-sent-${r.id}`} className="bg-emerald-600 px-3 text-xs font-semibold text-white disabled:opacity-40">Sent</button>
        </span>
      )}
    </div>
  );
};

export const RefundsList = () => {
  const [items, setItems] = useState([]);
  const load = useCallback(() => adminApi.get("/admin/payments/refunds").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load]);
  const todo = items.filter((r) => r.status !== "sent");
  return (
    <div data-testid="refunds-list" className="space-y-2">
      <p className="font-mono text-[11px] uppercase tracking-wider text-slate-400">Refunds to send ({todo.length})</p>
      {items.length === 0 && <p className="text-slate-500">No refunds.</p>}
      {[...todo, ...items.filter((r) => r.status === "sent").slice(0, 10)].map((r) => <Row key={r.id} r={r} onDone={load} />)}
    </div>
  );
};

export const LiveTest = ({ onDone }) => {
  const [amount, setAmount] = useState("1");
  const [paying, setPaying] = useState(false);
  return (
    <div data-testid="live-test" className="space-y-2 border border-sky-500/30 bg-sky-500/5 p-3 text-sm">
      <p className="font-semibold text-white">Live ₹1 test</p>
      <p className="text-xs text-slate-400">Click Start test, then from another UPI account pay the exact amount shown (e.g. ₹1.37) within 2 minutes. When the bank SMS reaches the webhook it is approved automatically. No UTR needed.</p>
      {paying && <UpiPay open note="Live UPI test" path="/admin/payments/live-test" body={{ amount: Number(amount) }} testId="live-test-pay"
        onClose={() => { setPaying(false); onDone(); }} onDone={() => { setPaying(false); onDone(); }} />}
      <div className="flex flex-wrap gap-2">
        <input value={amount} onChange={(e) => setAmount(e.target.value.replace(/\D/g, ""))} data-testid="live-test-amount" className={`${inp} w-20`} />
        <button disabled={!amount} onClick={() => setPaying(true)} data-testid="live-test-submit" className="bg-sky-600 px-3 text-xs font-semibold text-white disabled:opacity-40">Start test</button>
      </div>
    </div>
  );
};
